import classNames from 'classnames'
import Arrow from 'components/assets/icons/Arrow'
import Link from 'components/common/Link/Link'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { useContext } from 'react'
import ClientContext from 'contexts/ClientContext'
import style from './Back.module.scss'

const Back = ({ className, from, to }) => {
  const { t } = useTranslation()
  const { pathname, state } = useLocation()
  const navigate = useNavigate()
  const { color } = useContext(ClientContext)

  let backPath = null
  let label = ''

  const contactPathRegEx = /^\/contacts\/([a-z]|\d)+/
  const contractPathRegEx = /^\/contracts\/([a-z]|\d){24}$/
  const contractSubPathRegex = /^\/contracts\/([a-z]|\d){24}\/\S+/
  const claimPathRegEx = /^\/claims\/([a-z]|\d)+/

  if (state?.fromClaim) {
    const { claimsPersonConcerned, claimsClientInfo, singleContract } = state || {}
    let step = state?.step || 1
    const pages = [
      t('claim:applySteps.contract.backLabel'),
      t('claim:applySteps.insuredPerson.backLabel'),
      t('claim:applySteps.contacts.backLabel'),
      t('claim:applySteps.circumstances.backLabel')
    ]
    if (step === 3 && claimsClientInfo === false) step--
    if (step === 2 && (claimsPersonConcerned === false || claimsClientInfo === false)) step--
    if (step === 1 && singleContract) step--

    label = pages[step-1] ?? ''
  }

  if (contractPathRegEx.test(pathname)) {
    if (state?.fromClaim) {
      backPath = ''
    } else {
      backPath = '/contracts'
    }
  } else if (contactPathRegEx.test(pathname)) {
    backPath = '/contacts'
  } else if (contractSubPathRegex.test(pathname)) {
    const id = pathname.split('/')[2]
    backPath = `/contracts/${id}`
  } else if (claimPathRegEx.test(pathname)) {
    backPath = '/claims'
  }

  const goBack = () => {
    if (state?.fromClaim) {
      return navigate(-1)
    } else if (from) {
      return navigate(from, { state })
    } else if (state?.from) {
      const { from, ...newState } = state
      navigate(state.from, { state: newState })
    } else {
      navigate(backPath)
    }
  }

  return (
    (to || backPath !== null || from) && (
      <Link
        className={classNames(style.back, className)}
        label={
          <div className={style.link}>
            <Arrow className={style.arrow} styles={{ fill: color || '#0000C9' }} />
            <span className={style.label} style={{ color }}>{label || t('common:backLabel')}</span>
          </div>
        }
        onClick={() => goBack()}
        to={to || backPath}
        styles={{ color }}
      />
    )
  )
}

export default Back
